export default {
  //baseURL: 'https://localhost:5001',
  //baseURL: 'https://apihml2.novoassist.com.br/Vendas',
  //baseURL: 'https://hml.api1nas.com.br/Vendas' // HOMOLOGAÇÃO
  baseURL: 'https://prd.api1nas.com.br/Vendas' //PRODUÇÃO
}